import { render, staticRenderFns } from "./BigPlayButton.vue?vue&type=template&id=001ce554&lang=pug&"
import script from "./BigPlayButton.vue?vue&type=script&lang=ts&"
export * from "./BigPlayButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports